export function execute<T extends () => unknown>(callback: T): ReturnType<T> {
  return callback() as ReturnType<T>
}
